import * as React from 'react';
import { Price16 } from '@cian/ui-kit/icons';

import * as styles from './styles.css';

export const DiffUp: React.FC = () => {
  return (
    <div className={styles['price-diff-arrow']} style={{ transform: 'rotate(180deg)' }}>
      <Price16 color="error_100" display="block" />
    </div>
  );
};

DiffUp.displayName = 'DiffUp';
